var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 19 37 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,19 L47.5,19 C48.8807119,19 50,20.1192881 50,21.5 C50,22.8807119 48.8807119,24 47.5,24 L15.5,24 C14.1192881,24 13,22.8807119 13,21.5 C13,20.1192881 14.1192881,19 15.5,19 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8243243,29 L38.1756757,29 C39.1832222,29 40,30.1192881 40,31.5 C40,32.8807119 39.1832222,34 38.1756757,34 L14.8243243,34 C13.8167778,34 13,32.8807119 13,31.5 C13,30.1192881 13.8167778,29 14.8243243,29 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,39 L47.5,39 C48.8807119,39 50,40.1192881 50,41.5 C50,42.8807119 48.8807119,44 47.5,44 L15.5,44 C14.1192881,44 13,42.8807119 13,41.5 C13,40.1192881 14.1192881,39 15.5,39 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.e0ed6ef2f85216a7f9f95c44f37a25a9.svg";
export { ForwardRef as ReactComponent };